import { t } from '../../../locales';
import { useAuthStore } from '../../store/shared/auth-store';
import { featureFlag } from '../../entities/feature-flag';
import ActivityLogHeaderBtns from './pages/activity-log/components/header-btns.vue';
import { ReportsModulePolicy } from './policy';
import { hasMarketplace, marketplacesEnum } from '../../utils/marketplaces';

const reportsModuleRoutes = {
	path: 'reports',
	component: () => import('./module-layout.vue'),
	children: [
		{
			path: 'variant-price',
			component: () => import('./pages/variant-price/index.vue'),
			meta: {
				title: t('variant-price-report'),
				can: () => {
					const authStore = useAuthStore();
					if (authStore.isSubscriptionEnded) {
						window.location.href = '/store/subscribe/renew_package';
						return false;
					}
					return ReportsModulePolicy.canUseVariantPriceReport();
				},
				featureFlag: featureFlag.E_COMMERCE,
			},
		},
		{
			path: 'variant-sales',
			component: () => import('./pages/variant-sales/index.vue'),
			meta: {
				title: t('variant-sales-report'),
				can: () => {
					const authStore = useAuthStore();
					if (authStore.isSubscriptionEnded) {
						window.location.href = '/store/subscribe/renew_package';
						return false;
					}
					return ReportsModulePolicy.canUseVariantSalesReport();
				},
				featureFlag: featureFlag.E_COMMERCE,
			},
		},
		{
			path: 'orders-returns',
			component: () => import('./pages/orders-returns/index.vue'),
			meta: {
				title: t('reports.orders-returns-report'),
				can: () => {
					const authStore = useAuthStore();
					if (authStore.isSubscriptionEnded) {
						window.location.href = '/store/subscribe/renew_package';
						return false;
					}
					return ReportsModulePolicy.canUseReturnedOrdersReport();
				},
				featureFlag: featureFlag.E_COMMERCE,
			},
		},
		{
			path: 'products-alerts',
			component: () => import('./pages/products-alerts/index.vue'),
			meta: {
				title: t('reports.products-alerts-report'),
				can: () => {
					return ReportsModulePolicy.canUseProductsAlertsReport();
				},
				featureFlag: featureFlag.E_COMMERCE,
			},
		},
		{
			path: 'pricing-log',
			component: () => import('./pages/pricing-log/index.vue'),
			meta: {
				title: t('reports.pricing-log'),
				featureFlag: featureFlag.E_COMMERCE,
			},
		},
		{
			path: 'activity-log',
			component: () => import('./pages/activity-log/index.vue'),
			meta: {
				title: t('reports.activity-log'),
				headerExtraComponent: ActivityLogHeaderBtns,
				featureFlag: featureFlag.E_COMMERCE,
			},
		},
		{
			path: 'linked-variants',
			component: () => import('./pages/linked-variants/index.vue'),
			meta: {
				title: t('reports.linked-variants-report'),
				can: () => {
					const authStore = useAuthStore();
					if (authStore.isSubscriptionEnded) {
						window.location.href = '/store/subscribe/renew_package';
						return false;
					}
					return ReportsModulePolicy.canUseProductsLinkedVariantsReport();
				},
				featureFlag: featureFlag.E_COMMERCE,
			},
		},
		{
			path: 'fba-inventory',
			component: () => import('./pages/fba-inventory/index.vue'),
			meta: {
				title: t('reports.fba.title'),
				can: () => {
					return ReportsModulePolicy.canUseFbaInventoryReport() && hasMarketplace(marketplacesEnum.Amazon);
				},
				featureFlag: featureFlag.E_COMMERCE,
			},
		},
		{
			path: 'trendyol-log',
			component: () => import('./pages/trendyol-log/index.vue'),
			meta: {
				title: t('reports.trendyol-log'),
				can: () => {
					return ReportsModulePolicy.canUseTrendyolLogsReport();
				},
				featureFlag: featureFlag.E_COMMERCE,
			},
		},
		{
			path: 'transactions',
			component: () => import('./pages/transactions/index.vue'),
			meta: {
				title: t('reports.transactions'),
				can: () => {
					const authStore = useAuthStore();
					if (authStore.isSubscriptionEnded) {
						window.location.href = '/store/subscribe/renew_package';
						return false;
					}
					return ReportsModulePolicy.canUseTransactionsReport();
				},
			},
		},
	],
};

export { reportsModuleRoutes };
